import { TourType } from '@api/v3';

export const roomSelection = (
  hotelName: string,
  roomName: string,
  hotelId?: number
) => {
  dataLayer.push({
    event: 'room_selection1',
    ecommerce: {
      prod_id: hotelId?.toString(),
      prod_name: hotelName,
      room_name: roomName,
    },
  });
};
export const roomVariationSelection = (
  hotelId: string,
  hotelName: string,
  isDomestic: boolean,
  price: number,
  roomType?: string
) => {
  dataLayer.push({
    event: 'room_selection2',
    ecommerce: {
      prod_name: hotelName,
      prod_id: hotelId,
      prod_cat: isDomestic ? 'Yurtiçi Otelleri' : 'Yurtdışı Otelleri',
      room_price: price?.toString(),
      room_type: roomType,
    },
  });
};

export const tourSelection = (
  name?: string,
  tourId?: number,
  prodDate?: string,
  tourType?: TourType
) => {
  dataLayer.push({
    event: 'tour_selection1',
    ecommerce: {
      prod_name: name,
      prod_id: tourId?.toString(),
      prod_cat:
        tourType === TourType.DOMESTIC_CULTURE
          ? 'Yurtiçi Tur'
          : tourType === TourType.CRUISE
          ? 'Gemi Turu'
          : 'Yurtdışı Tur',
      prod_date: prodDate,
    },
  });
};
export const tourVariationSelection = (
  tourId?: number,
  tourName?: string,
  tourType?: TourType,
  price?: number
) => {
  dataLayer.push({
    event: 'tour_selection2',
    ecommerce: {
      prod_name: tourName,
      prod_id: tourId?.toString(),
      prod_cat:
        tourType === TourType.DOMESTIC_CULTURE
          ? 'Yurtiçi Tur'
          : tourType === TourType.CRUISE
          ? 'Gemi Turu'
          : 'Yurtdışı Tur',
      room_price: price?.toString(),
    },
  });
};
